// Load Bootstrap JS
import bootstrap from 'bootstrap'

// Load Styles
import '../scss/main.scss';
import initFixedMenu from "./modules/init_fixed_menu";
import initCalendar from "./modules/init_calendar";
import AOS from 'aos/dist/aos.js';

// Demo of using .env variables
// console.log(`Google Maps API Key: ${process.env.GOOGLE_MAPS_API_KEY}`);

document.addEventListener("DOMContentLoaded", () => {
  initFixedMenu();
  initCalendar();
  AOS.init({
    duration: 1000, // values from 0 to 3000, with step 50ms
    easing: 'ease-out-cubic',
  });


  const kuCollapsible = document.querySelectorAll('.yo-accordion--wrapper');
  kuCollapsible.forEach(ele=>{
    ele.addEventListener('hidden.bs.collapse', event => {
      AOS.refresh();
    })
  })

});
